<template>
  <div class="allWrap mt-5">
    <div class="inputWrap" v-if="timeMsg == ''">
      <h4 class="tit1 text-center">雲閃付轉銀行卡收銀臺</h4>
      <img class="mt-3 ysfbank_qrCode" :src="order.qr_url" alt />
      <p class="dangerText mt-3">[手機上顯示該頁面，請打開 雲閃付APP，點擊“收付款”點擊“上滑掃一掃”]</p>
      <div class="row ">
        <div class="col-12">
          <h5 class="ml-1 text-white text-left">轉帳金額：¥{{order.real_price}}</h5>
        </div>
        <div class="col-md-6 col-12">
          <div class="wallet_name m-0">
            <input
              class
              type="text"
              placeholder="請輸入聯絡人帳號"
              onfocus="addInputStyle(this)"
              onblur="removeInputStyle(this)"
              disabled
            />
            <div class="icon">
              <div class="icon_bg">
                <i class="fa fas fa-user"></i>
              </div>
            </div>
            <p>帳號</p>
            <div class="account_name">
              <p>帳號</p>
              銀行卡姓名 : {{order.bank_owner}}
              <em class="fas fa-user-lock lock"></em>
              <button v-clipboard:copy="order.bank_owner" class="btn btn-green copyBtn">複製</button>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="wallet_name m-0">
            <input
              class
              type="text"
              placeholder="請輸入聯絡人帳號"
              onfocus="addInputStyle(this)"
              onblur="removeInputStyle(this)"
              disabled
            />
            <div class="icon">
              <div class="icon_bg">
                <i class="fa fas fa-user"></i>
              </div>
            </div>
            <p>帳號</p>
            <div class="account_name">
              <p>帳號</p>
              銀行卡號 : {{order.bank_no}}
              <em class="fas fa-user-lock lock"></em>
              <button v-clipboard:copy="order.bank_no" class="btn btn-green copyBtn">複製</button>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12">
          <div class="wallet_name m-0">
            <input
              class
              type="text"
              placeholder="請輸入聯絡人帳號"
              onfocus="addInputStyle(this)"
              onblur="removeInputStyle(this)"
              disabled
            />
            <div class="icon">
              <div class="icon_bg">
                <i class="fa fas fa-user"></i>
              </div>
            </div>
            <p>帳號</p>
            <div class="account_name">
              <p>帳號</p>
              開戶銀行 : {{order.bank_name}}
              <em class="fas fa-user-lock lock"></em>
              <button v-clipboard:copy="order.bank_name" class="btn btn-green copyBtn">複製</button>
            </div>
          </div>
        </div>
        <div class="col-md-6 col-12" v-if="order.memo_id">
          <div class="wallet_name m-0">
            <input
              class
              type="text"
              placeholder="請輸入聯絡人帳號"
              onfocus="addInputStyle(this)"
              onblur="removeInputStyle(this)"
              disabled
            />
            <div class="icon">
              <div class="icon_bg">
                <i class="fa fas fa-user"></i>
              </div>
            </div>
            <p>備註</p>
            <div class="account_name">
              <p>備註</p>
              備註 :{{order.memo_id}}
              <em class="fas fa-user-lock lock"></em>
              <button v-clipboard:copy="order.memo_id" class="btn btn-green copyBtn">複製</button>
            </div>
          </div>
          <p class="text-danger text-right w-100">↑請務必填寫此備註，否則充值將無法成功到帳!</p>
        </div>
      </div>

      <p class="ml-2 mt-1 text-left">操作步驟</p>
      <p class="ml-2 mt-1 text-left">
        1.打開雲閃付請打開您的
        <span class="text-danger">[雲閃付]</span>
      </p>
      <p class="ml-2 mt-1 text-left">
        2.在雲閃付中操作點擊
        <span class="text-danger">【轉賬】</span>→
        <span class="text-danger">【轉到銀行卡】</span>
      </p>
      <p class="ml-2 mt-1 text-left">
        3.複製銀行卡信息錄入依次複製
        <br class="stepBr" />
        <span class="text-danger">【卡號】</span>、
        <span class="text-danger">【姓名】</span>、
        <span class="text-danger">【金額】</span>
      </p>

      <p class="text-danger dangerText text-left">[請先輸入卡號，再輸入姓名。請務必按照金額轉賬，否則不會自動到賬！！！]</p>
    </div>

    <div v-else>
      <h4 class="tit1">{{timeMsg}}</h4>
    </div>
  </div>
</template>
<style lang="scss" scoped>
</style>
<script>
import axios from "axios";
export default {
  data() {
    return {
      order: "",
      timeout: "",
      timeMsg: ""
    };
  },
  computed: {},
  methods: {
    getOrder() {
      axios
        .get(
          `${process.env.VUE_APP_DEFAULT_SRC}query?transaction_id=${this.$route.query.transaction_id}`
        )
        .then(res => {
          if (res.data.code == 0) {
            this.order = res.data.data;
          } else {
            this.timeMsg = res.data.message;
            clearInterval(this.timeout);
          }
        });
    }
  },
  created() {
    this.getOrder();
    this.timeout = setInterval(() => this.getOrder(), 60000);
  }
};
</script>